<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <commissions-total></commissions-total>
        <commissions-stats></commissions-stats>
        <commissions-table></commissions-table>
    </b-col>
</template>

<script>
    import CommissionsTotal from './commissions/CommissionsTotal.vue'
    import CommissionsStats from './commissions/CommissionsStats.vue'
    import CommissionsTable from './commissions/CommissionsTable.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'

    export default {
        dependencies: ['popup', 'totalIncomes'],
        components: { CommissionsTotal, CommissionsStats, CommissionsTable, FuturocoinsFromMining },
        mounted () {
            this.totalIncomes.fetchData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/CommissionsContent.vue